<template>
  <div class="h-100">
    <div style="height:55px;border-bottom: 1px solid #1e1e1e;padding:8px 0px;" class="filter-fields-in-logs w-100">
      <!-- <div class="search-bar-comm-style comm-div" style="width:27%;inset-inline-end:0px !important;height:38px;padding:0px !important;inset-inline-start:0px !important">
          <input
            type="text"
            v-model="fileNameFilter"
            class="bg-transparent rounded text-light w-100"
            placeholder="Search by filename..."
            @focus="showUserFilter = false"
            @keyup="refreshAuditLogs(false);"
            style="top:0px;border:1px solid #292828 !important;padding-inline-start:0px !important;width:95% !important;padding-inline-start:11% !important;background: #121212 !important;"
          />
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-search"
            fill="#c5c0c0"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
            fill-rule="evenodd"
            d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"
            />
            <path
            fill-rule="evenodd"
            d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
            />
           </svg>
        </div> -->

      <!-- <div> ------------------------------ commented before
        <label>User</label>
          <div class="value-style d-inline-flex w-100" style="inset-inline-end:0px;bottom:8px;position:relative">
           <input
                @focus="getusersOnKeyup"
                v-on:keyup="getusersOnKeyup"
                placeholder="select user"
                type="text"
                v-model="searchByUser"
                class="bg-transparent border rounded text-light input-fields w-100 pl-2"
              />
              <div class="panel-footer autocomplete-box col-xl-12 p-2"
               v-show="userListFromAutocomplete.length > 0" style="position:absolute;top:100%">
              <ul class="list-group" v-click-outside="hideUsersDropdown">
                <li v-for="userInfo in userListFromAutocomplete"
                 :key="userInfo._id"
                  @click="selectedUserInfo._id=userInfo._id;searchByUser=userInfo.username; refreshAuditLogs(false);userListFromAutocomplete = []" 
                  class="list-group-item autocomplete-box-li m-0 p-0">
                    {{ userInfo.username }}
                </li>
              </ul>
          </div>
          </div>
      </div> -->


       <!-- <li>
            <div class="config-label">Users</div>
            <div class="config-value">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <Multiselect
                          v-model="searchKey"
                          :options="userListFromAutocomplete"
                          :custom-label="selectionLabelCallback"
                          :track-by="username"
                          placeholder="Search User"
                          :hideSelected="false"
                          :close-on-select="true"
                          :limit="1"
                          deselectLabel=""
                          selectLabel=""
                          selectedLabel=""
                          :resetAfter="false"
                          :showNoOptions="false"
                          @open="getAllUserNamesFromServer"
                          @search-change="getusersOnKeyup($event)"
                          @select="updateUsersFilter($event)"
                          @remove="optionsOnRemoveCallback()">
                          <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                          <div class="user-name-or-image" :style="style(scope.option.username)">{{ scope.option.username.split("")[0] }}</div>
                          <span style="margin-inline-start:12px;">{{ scope.option.username }}</span>
                          </div>
                          <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option">
                          <span style="margin-inline-start:12px;">ALL</span>
                          </div>
                          <span slot="noResult">No results.</span>
                        </Multiselect>
                    </div> 
                </div>       
            </div>
        </li> -->



      <!-- <div> --------------------------- commented before
        <label>Group</label>
        <div class="value-style d-inline-flex w-100" style="inset-inline-end:0px;bottom:8px;position:relative">
           <input
                @focus="getUserGroupsOnKeyup"
                v-on:keyup="getUserGroupsOnKeyup"
                placeholder="select user"
                type="text"
                v-model="searchByUserGroup"
                class="bg-transparent border rounded text-light input-fields w-100 pl-2"
              />
              <div class="panel-footer autocomplete-box col-xl-12 p-2"
               v-show="showUserFilter" style="position:absolute;top:100%">
              <ul class="list-group">
                <li v-for="userGroupInfo in userGroupListFromAutocomplete"
                 :key="userGroupInfo._id"
                  @click="selectedUserGroupInfo=userGroupInfo; refreshAuditLogs(false)" 
                  class="list-group-item autocomplete-box-li m-0 p-0">
                    {{ userGroupInfo.username }}
                </li>
              </ul>
          </div>
          </div>
      </div> -->
      <!-- <div>
        <label>Actions</label>
        <select class="bg-transparent rounded text-light pl-1" style="width:60%"
           v-model="filterByAction" @change="refreshAuditLogs(false)" @focus="showUserFilter = false">
           <option value="All" selected>All</option>
           <option value="Create">Create</option>
           <option value="Modify">Modify</option>
           <option value="Delete">Delete</option>
            <option v-for="item in getJobNames()" v-bind:key="item.action_name" :value="item.action_name">{{item.label}}</option>
          </select>
      </div> -->

       <!-- <li>
            <div class="config-label">Job</div>
            <div class="config-value">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <Multiselect
                            @focus="showUserFilter = false"
                            :value="selectedJobName"
                            :options="getJobNames()"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            :label="job_name"
                            :showNoOptions="false"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            style="margin-inline-start:6px;"
                            @select="updateJobNameFilter($event)" 
                            
                            :track-by="getJobNames.job_status">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                            </div>
                            <span slot="noResult">No results.</span>
                        </Multiselect>
                    </div>
                </div>       
            </div>
        </li> -->
      <!-- <div class="comm-div" style="margin-inline-end:10px">
        <label class="config-label">Date</label>
        <Datepicker
                range
                @focus="showUserFilter=false"
                v-model="time1"
                valueType="format"
                @change="refreshAuditLogs(false)"
                class="bg-transparent rounded  text-light"
                style="height:38px !important;"
              ></Datepicker>
      </div> -->

       <filters-top-bar 
        v-bind="currentAuditTrailReportProperties"
        @changeSelectedReportComponent="changeSelectedReportComponent"
        @reloadAuditTrail="reloadAuditTrail">
      </filters-top-bar>
      <button-top-bar
        v-on:click.native="downloadAuditTrailReportData()"
        style="margin: 0 !important; margin-inline-start: 9px !important;"
      >
      </button-top-bar>
    </div>
    <div class="user-logs-table" style="margin-top: 16px;">
      <table class="table table-with-border table-scroll small-first-col"  style="background: transparent">
      <thead style="color: #eee">
          <tr>
            <th style="width: 18%" class="text-left">{{$t('Username')}}</th>
            <th style="width: 16%">{{$t('DateTime')}}</th>
            <th style="width: 12%;text-align:start">{{$t('Category')}}</th>
            <th style="width: 12%;" class="text-left">{{$t('Action')}}</th>
            <th style="width: 40%;" class="text-left">{{$t('Object')}}</th>
            <!-- <th style="width: 30%" class="text-left">Summary</th> -->
          <th style="width: 2%"></th>
          </tr>
        </thead>
      <tbody v-if="auditLogsData.length">
          <tr
            v-for="logs in auditLogsData"
            :key="logs._id"
            class="ccomm-logs-row" :class="{activeclass: activeIndex === logs._id}">
            <td class="text-left" style="position:relative">
              <span v-if="Object.keys(logs).includes('user_id') && logs.user_id.length > 0" :title="logs.username" class="text-ellipsis">{{logs.username }}</span>
             
              <span v-else class="validationmessage">No Data found</span>
            </td>
            <!-- <td>{{moment(logs.created_datetime).format("DD/MM/YYYY h:mm:ss a")}}</td> -->
            <td>
              <!-- <span v-if="Object.keys(logs).includes('action_datetime') && logs.action_datetime.length > 0">{{formatedDate(logs.action_datetime)}}</span> -->
              <span v-if="Object.keys(logs).includes('action_datetime') && logs.action_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(logs.action_datetime)">{{checkIsTodayoryesterdayDate(logs.action_datetime)?getDateAndTimeInConfiguredFormat(logs.action_datetime, true):getDateAndTimeInConfiguredFormat(logs.action_datetime)}}</span>
              <span v-else class="validationmessage">No Data found</span>
            </td>
            <td style="text-align:start">
              <span v-if="Object.keys(logs).includes('category') && logs.category.length > 0">{{logs.category}}</span>
              <span v-else class="validationmessage">No Data found</span>
            </td>
            <td class="text-left">
              <span v-if="Object.keys(logs).includes('action') && logs.action.length > 0">{{logs.action}}</span>
              <span v-else class="validationmessage">No Data found</span>
            </td>
            <td class="text-left">
              <div v-if="Object.keys(logs).includes('object') && logs.object.length > 0" style="word-break:break-word">{{logs.object}}</div>
              <span v-else class="validationmessage">No Data found</span>
              <div v-if="Object.keys(logs).includes('summary') && logs.summary.length > 0" class="dull-the-text" style="word-break:break-word">{{logs.summary}}</div>
            </td>
            <!-- <td class="text-left">
              <span v-if="Object.keys(logs).includes('summary') && logs.summary.length > 0" style="word-break:break-word">{{logs.summary}}</span>
              <span v-else class="validationmessage">No Data found</span>
            </td> -->
            <td>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" v-on:click="showSelectedLogDetails(logs)" class="bi bi-info-circle-fill jobs-info-icon" viewBox="0 0 16 16">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
              </svg>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
            <tr>
                <td colspan="6" class="dull-the-text">No Data Found</td>
            </tr>
        </tbody> 
    </table>
    </div>
    <div>
    <pagination
        v-model="page"
        :records="totalUsersLogs"
        :per-page="perPage"
        @paginate="paginate"
        :options="options"
        :first = "Prev"
        :last = "Next"
        style="margin-top:10px"
    />
    </div>
    <audittrail-details v-if="isLogDetailsVisible" v-bind="jobCompleteDetails"
      @close="closeModal"></audittrail-details>
    </div>
</template>

<script>
import { mapActions,mapGetters } from "vuex";
import Pagination from "vue-pagination-2";
// import DatePicker from "vue2-datepicker";
// import "vue2-datepicker/index.css";
import Utils from "../../components.utils.js"
import AuditTrailLogDetails from "./AuditTrailLogDetails.vue"
// import Multiselect from 'vue-multiselect';
import buttonsTopbar from "./headerbar.vue";
import FiltersTopbar from "./filtersBar.vue";
// import {NotifierConstants} from "../../components.constants.js";

export default {
  data() {
    return {
      logInfo:null,
      isLogDetailsVisible:false,
      auditLogsData: [],
      auditLogUserMap:{},
      page: 1,
      totalPages: -1,
      totalUsersLogs: -1,
      perPage: -1,
      userNameIdMap:{},
      time1:null,
      selectedUserInfo:{},
      selectedUserGroupInfo:{},
      filterBy:{},
      userListFromAutocomplete:[],
      userGroupListFromAutocomplete:[],
      searchByUser:"",
      showUserFilter:false,
      showUserGroupFilter:false,
      searchByGroup:"",
      fileNameFilter:"",
      filterByAction:{
        state:"All",
        job_name:"All"
      },
      options:{chunk:5},

      selectedJobName:"All",
      searchKey:"",
      payloadParams:{},
      activeIndex:null,
    };
  },
  components:{
    pagination: Pagination,
    // "Datepicker":DatePicker,
    "audittrail-details":AuditTrailLogDetails,
    // Multiselect,
    "button-top-bar":buttonsTopbar,
    "filters-top-bar":FiltersTopbar,
  },
  computed:{
    jobCompleteDetails(){
      return {selectedLogInfo:this.logInfo}
    },
    currentAuditTrailReportProperties() {
      return { reportContext : "auditTrail"};
    },
  },
  methods: {
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    changeSelectedReportComponent(filtersdata){
        this.payloadParams = filtersdata;
        this.page = 1;
        this.refreshAuditLogs(false);
    },
    showSelectedLogDetails(logDetails){
      this.logInfo = logDetails;
      this.activeIndex = logDetails._id;
      this.isLogDetailsVisible = true;
    },
    closeModal() {
      this.isLogDetailsVisible = false;
      this.activeIndex = null;
    },
    formatedDate(date){
      return Utils.getDateTimeFormat(date);
    },
    getUserNameFromId(userId){
      let username = ""
      if(this.auditLogUserMap.length > 0){
        let usermap = this.auditLogUserMap.filter((usersMap)=>(usersMap.user_id == userId))
        if(typeof usermap != "undefined"){
          username = usermap[0].username
        }
      }
      return username
    },
    paginate() {
      // this.page = page;
      this.refreshAuditLogs(true);
    },
    // getusersOnKeyup(){
    //   this.showUserFilter = true
    //   this.showUserGroupFilter = false
    //   let payload = {}
    //   if(typeof(this.searchByUser) != "undefined" && this.searchByUser.trim().length > 0){
    //   payload.params = {username:this.searchByUser}
    //   this.getUsersAutoComplitionFromServer(payload).then((data) => {
    //     this.userGroupListFromAutocomplete = [];
    //     this.userListFromAutocomplete = data["users"];
    //   });
    //   }else if(this.searchByUser.length==0){
    //     delete this.selectedUserInfo._id;
    //     this.refreshAuditLogs(false)
    //      this.getAllUsersFromServer(payload).then((data) => {
    //       this.userListFromAutocomplete = data.users;
    //     });
    //   }
    // },


    getusersOnKeyup(option){
      this.showUserFilter = true
      this.showUserGroupFilter = false
      let payload = {}
      // if(typeof(option) != "undefined" && option.trim().length > 0){
      if(typeof(option) != "undefined" && option.length > 0){  
        payload.params = {username:option}
        this.getUsersAutoComplitionFromServer(payload).then((data) => {
          this.userGroupListFromAutocomplete = [];
          this.userListFromAutocomplete = data["users"];
        });
      }else if(option.length==0){
        // this.updateUsersList(false);
        // this.filterBy.user_id = "";
        // this.updateJobsListFromServer(false,true, option);
        // this.userListFromAutocomplete = this.usersList;
        // delete this.selectedUserInfo._id;
        // this.refreshAuditLogs(false)
        this.getAllUsersFromServer(payload).then((data) => {
          this.userListFromAutocomplete = data.users;
        });
      }
    },

    getAllUserNamesFromServer(){
        this.getAllUsersFromServer().then((data) => {
          this.userListFromAutocomplete = data.users;
        });
    },

    hideUsersDropdown(){
      if(this.userListFromAutocomplete.length > 0 && this.searchByUser.length==0){
        this.userListFromAutocomplete = [];
      }
    },
    selectionLabelCallback(option){
        return `${option.username}`
    },
    updateUsersFilter(option){
      this.selectedUserInfo["_id"] = option._id;
      this.searchKey = option.username;
      this.refreshAuditLogs(false);
    },
    getUserGroupsOnKeyup(){
      this.showUserGroupFilter = true
      this.showUserFilter = false
      let payload = {};
      payload.params = {user_id: this.selectedUserID};
      this.getAllUserGroupsFromServer(payload).then((data)=>{
        this.userGroupListFromAutocomplete = data.user_groups;
      });
    },
    optionsOnRemoveCallback(){
      this.searchKey = "";
      this.userListFromAutocomplete = [];
      // this.updateUsersList(false)
    },

    updateJobNameFilter(option){
      this.filterByAction["job_name"] = option.action_name;
      this.selectedJobName = option.action_name;
      // this.updateJobsListFromServer(false,true);
      this.refreshAuditLogs(false)
    },

    getJobNames(){
      var jobsNameList = this.getActionListFromInMem().filter((action)=>action.executed_as_job == true)
       jobsNameList.unshift({
          _id:"All",
          action_name:"All"
        },{
          _id:"Create",
          action_name:"Create"
        },{
          _id:"Modify",
          action_name:"Modify"
        },{
          _id:"Delete",
          action_name:"Delete"
        });
      return jobsNameList;
      },
    refreshAuditLogs(isPageClick = false, forceUpdate = false) {
      // this.showUserFilter = false
      // this.showUserGroupFilter = false
      let payload = {}
      // let paramsInfo = {}
      if(isPageClick){
        this.payloadParams.page = this.page
      }
      
      // if(typeof this.selectedUserInfo != "undefined"){
      //   paramsInfo.user_id = this.selectedUserInfo._id
      // }
      // if(typeof this.selectedUserGroupInfo != "undefined"){
      //   paramsInfo.group_id = this.selectedUserGroupInfo._id
      // }
      // if(typeof this.time1 != "undefined" &&
      //  this.time1 != null && this.time1.length == 2 && this.time1[0] != null){
      //   paramsInfo.from_date = this.time1[0]+"T00:00:00"
      //   paramsInfo.to_date = this.time1[1]+"T00:00:00"
      // }
      // if(typeof this.fileNameFilter != "undefined" && this.fileNameFilter.trim().length > 0){
      //   paramsInfo["file_name"] = this.fileNameFilter
      //   paramsInfo.filter=JSON.stringify(["file_name"])
      // }

      // if(typeof this.filterByAction != "undefined" && (this.filterByAction.job_name.trim() <= 0 || this.filterByAction.job_name.trim() != "All")){
      //   paramsInfo["action"] = this.filterByAction.job_name;
      // }
      // payload.params = paramsInfo
      payload.params =this.payloadParams;
      payload.isPrivExists = this.isPrivilegeExists('reports');
      this.getAllAuditLogsFromServer(payload).then((data) => {
        this.totalPages = data["page_count"];
        //this.page = data["page"];
        this.totalUsersLogs = data["total_user_logs"];
        this.perPage = data["user_logs_per_page"];
        this.auditLogsData = data.user_logs;
        this.auditLogUserMap = data.user_map;
        this.userListFromAutocomplete = []
        this.userGroupListFromAutocomplete = [];
        if(forceUpdate){
          this.$toast.info("Refreshed !")
        }
      }); 
    },
    isPrivilegeExists(privilegeName){
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), privilegeName);
    },

    reloadAuditTrail(){
      this.refreshAuditLogs(false, true);
    },

    // downloadAuditTrailReportData() {
    //   let payload = {}
    //   // let downloadparamsInfo = {}
      
      
    //   // if(typeof this.selectedUserInfo != "undefined"){
    //   //   downloadparamsInfo.user_id = this.selectedUserInfo._id
    //   // }
    //   // if(typeof this.selectedUserGroupInfo != "undefined"){
    //   //   downloadparamsInfo.group_id = this.selectedUserGroupInfo._id
    //   // }
    //   // if(typeof this.time1 != "undefined" &&
    //   //  this.time1 != null && this.time1.length == 2 && this.time1[0] != null){
    //   //   downloadparamsInfo.from_date = this.time1[0]+"T00:00:00"
    //   //   downloadparamsInfo.to_date = this.time1[1]+"T00:00:00"
    //   // }
    //   // if(typeof this.fileNameFilter != "undefined" && this.fileNameFilter.trim().length > 0){
    //   //   downloadparamsInfo["file_name"] = this.fileNameFilter
    //   //   downloadparamsInfo.filter=JSON.stringify(["file_name"])
    //   // }

    //   // if(typeof this.filterByAction != "undefined" && (this.filterByAction.job_name.trim() <= 0 || this.filterByAction.job_name.trim() != "All")){
    //   //   downloadparamsInfo["action"] = this.filterByAction.job_name;
    //   // }
    //   // payload.params = downloadparamsInfo

    //   let downloadParams = this.payloadParams;
    //   delete downloadParams.page;
    //   payload.params = downloadParams;

    //   this.downloadAuditTrailReportFromServer(payload).then((response) => {
    //   const blob = new Blob([response.data], {
    //       type: "application/vnd.csv",
    //   });
    //   const link = document.createElement("a");
    //   link.href = URL.createObjectURL(blob);
    //   link.setAttribute(
    //       "download",
    //       response.headers["content-disposition"].split("filename=")[1]
    //   );
    //   document.body.appendChild(link);
    //   link.click();
    //   })
    //   .catch(console.error);
    // },

     downloadAuditTrailReportData() {
        // let filePath = url;
        let payload = {};
        payload.params = this.payloadParams;
        this.$toast.info("You will be notified once the report is ready to download");
        if (this.isPrivilegeExists('reports')){
          this.downloadAuditTrailReportFromServer(payload).then(() => {
            console.log("Downloading report")
          // const blob = new Blob([response.data], {
          //     type: "application/vnd.csv",
          // });
          // const link = document.createElement("a");
          // link.href = URL.createObjectURL(blob);
          // link.setAttribute(
          //     "download",
          //     response.headers["content-disposition"].split("filename=")[1]
          // );
          // document.body.appendChild(link);
          // link.click();
          })
          .catch(console.error);
        }else{
          this.downloadSessionAuditTrailReportFromServer(payload).then(() => {
          console.log("Downloading report")
        })
        .catch(console.error);
        }
    },
    
    /* COMMENTED TO FIX FA-4591 */
    // handleAuditTrailNotification(notification){
    //   notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
    //   if(notification.message){
    //     this.refreshAuditLogs(false)
    //   }
    // },
    // registerforWebsocketNotifications(){
    //   this.addWSEventListener({
    //     eventname:Object.values(NotifierConstants),
    //     callback:this.handleAuditTrailNotification,
    //     parent: "ShowAuditTrails"})
    // },
    // unRegisterforWebsocketNotifications(){
    //   this.removeWSEventListener({
    //     eventname:Object.values(NotifierConstants),
    //     callback:this.handleAuditTrailNotification,
    //     parent: "ShowAuditTrails"})
    // },

    ...mapActions("auditTrails", ["getAllAuditLogsFromServer", "downloadAuditTrailReportFromServer","downloadSessionAuditTrailReportFromServer"]),
    ...mapActions("users", ["getAllUsersFromServer","getUsersAutoComplitionFromServer"]),
    ...mapGetters("privileges",["getActionListFromInMem"]),
    // ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapGetters("users",["getLoggedInUser","getLoggedInUserId"]),
    ...mapGetters("users",["getLoggedInUserPrivilege"])
  },
  // beforeDestroy(){
  //   this.unRegisterforWebsocketNotifications()
  // },
  name:'auditTrail',
  created() {
    this.searchByUser = this.getLoggedInUser()
    this.selectedUserInfo._id= this.getLoggedInUserId();
    this.showUserFilter = false;
    let loggedInUserIdInList = [];
    loggedInUserIdInList.push(this.getLoggedInUserId());
    this.payloadParams["user_id"] = JSON.stringify(loggedInUserIdInList);
    this.refreshAuditLogs(false);
    // this.registerforWebsocketNotifications()
}
};
</script>



<style scoped lang="scss">
    $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.jobs-info-icon{
  visibility:hidden;
}

.ccomm-logs-row:hover {
  .jobs-info-icon{
    visibility:visible;
  }
}

.ccomm-logs-row:hover{
  color: $active-blue;
}

.validationmessage{
  color:$danger-color;
}

.activeclass {
  color: $active-blue;
}

.modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    pointer-events: all;
    background: $primary-background !important;
}

.sidebar-menu {
    background: #857d7d !important;
}
.value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
    }

    .filter-fields-in-logs{
      display: inline-flex;
      div{
        display:inline-flex;
        div.comm-div{
            display:inline-flex;
            width:25%;
            // padding-top:7px;
            position: relative;
            // inset-inline-end :2%;
            label{
            color:$dull-text-color;
            position: relative;
            inset-inline-end: 5px;
            width:30%;
            text-align:end;
            top:2px;
            }
            select,input{
            width:70%;
            height:27px;
            border:$border-color !important;
            }
        }
      }  
    }
.table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th{
            position: sticky;
            top: 0;
            background:$primary-background;
            z-index:9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr{
            height:60px;
            }
        }
    }

.table{
  color:#fff !important;
  th{
    border-top:none !important;
    padding: 1rem !important;
  }
  td{
    border-top:none !important;
    padding: 1rem !important;
  }
}

.table-with-border {
  thead {
    border-bottom: none;
  }
  tr {
    border-bottom: none;
  }
}

tbody tr{
    border-bottom: $secondary-border-color;
}

.comm-user-row:hover {
  color: $active-blue;
  td:first-child {
    text-decoration: underline;
  }
}

.user-logs-table{
  height: calc(100% - 115px);
  overflow:auto;
  padding: 0 30px 10px 30px;
}
.height-set-for-component {
  height: calc(100% - 170px);
}

.search-bar-comm-style {
        height: 30px;
        position: relative;
        input {
            border: $border-color !important;
            position: absolute;
            top: 12%;
            inset-inline-start:15%;
            height: 38px !important;
            padding-inline-start: 8%;
        }
        svg {
            position: absolute;
            inset-inline-start:24px;
            top: 34%;
        }
    }

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.activestatus {
  color: #28a745 !important;
}

  .user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
  }

  .user-name{
      margin-inline-end: 10px;
      position: relative;
      bottom: 7px;
  }
  
  input:focus{
    outline:none;
    box-shadow: none;
  }

  .dull-the-text{
    color: $secondary-text-color;
  }

  .text-ellipsis{
    white-space: nowrap; 
    width: 88%; 
    overflow: hidden;
    text-overflow: ellipsis; 
    display: block;
    position: absolute;
  }

::v-deep{
.mx-input{
    background-color: $primary-background  !important;
    border: none !important;
    color: $text-color !important;
    height:100%;
}
.mx-input-wrapper{
  width:100%;
  height:100%;
}
.mx-datepicker-main{
    border: $border-color !important;
    background: $secondary-background-color !important;
}
.mx-calendar-content .cell:hover{
    background-color: $bg-color-on-hover !important;
}
.mx-datepicker-range{
  width:100%;
  height:100% !important;
}
.mx-calendar-content .cell:hover {
    color: #000000;
    background-color: #7d99b1;
}
.mx-datepicker{
  width:100% !important;
  padding: 0 !important;
  border:$border-color !important;
  height: 27px !important;
}
.mx-icon-calendar, .mx-icon-clear{
      color: #d7d2d280;
}
} 

  li {
      width: 25%;
      display: inline-flex;
      // margin-bottom: 20px;
  }

  .config-label {
      width: 26% !important;
      text-align: end;
      color: #757575;
      word-break: break-word;
      position: relative !important;
      top: 9px !important;
  }
  
  .config-value {
      margin-inline-start: 4px;
      width: 95% !important;
      display:grid;
      svg{
          position: relative;
          top: 9px;
          margin-inline-start: 10px;
      }
  }


::v-deep {
         .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-start;
    display: none;
    margin-inline-start: 5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 190px !important;
  }
}    

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
</style>

